export default __webpack_public_path__ + "static/media/banker_1.24a1be21.mp3";